import { render, staticRenderFns } from "./ForeignCompanyFile.vue?vue&type=template&id=263cc9f9&scoped=true&"
import script from "./ForeignCompanyFile.vue?vue&type=script&lang=js&"
export * from "./ForeignCompanyFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263cc9f9",
  null
  
)

export default component.exports